/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitDtoV2 } from './PaymentSplitDtoV2';
import {
    PaymentSplitDtoV2FromJSON,
    PaymentSplitDtoV2FromJSONTyped,
    PaymentSplitDtoV2ToJSON,
    PaymentSplitDtoV2ToJSONTyped,
} from './PaymentSplitDtoV2';
import type { InitiateUnintegratedPaymentV2Request } from './InitiateUnintegratedPaymentV2Request';
import {
    InitiateUnintegratedPaymentV2RequestFromJSON,
    InitiateUnintegratedPaymentV2RequestFromJSONTyped,
    InitiateUnintegratedPaymentV2RequestToJSON,
    InitiateUnintegratedPaymentV2RequestToJSONTyped,
} from './InitiateUnintegratedPaymentV2Request';

/**
 * 
 * @export
 * @interface MobileCardTerminal
 */
export interface MobileCardTerminal extends InitiateUnintegratedPaymentV2Request {
}



/**
 * Check if a given object implements the MobileCardTerminal interface.
 */
export function instanceOfMobileCardTerminal(value: object): value is MobileCardTerminal {
    return true;
}

export function MobileCardTerminalFromJSON(json: any): MobileCardTerminal {
    return MobileCardTerminalFromJSONTyped(json, false);
}

export function MobileCardTerminalFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileCardTerminal {
    return json;
}

export function MobileCardTerminalToJSON(json: any): MobileCardTerminal {
    return MobileCardTerminalToJSONTyped(json, false);
}

export function MobileCardTerminalToJSONTyped(value?: MobileCardTerminal | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

